import Vue from 'vue';
import VueSlideOutPanel from 'vue2-slideout-panel';

const slideOutPanelPlugin = {
    register() {
        Vue.use(VueSlideOutPanel);
    }
};

export default slideOutPanelPlugin;